import React from "react";
import EyeIcon from "cc-ss-components/EyeIcon";

export default function EyeIconExample() {
    return <EyeIcon />;
}


// WEBPACK FOOTER //
// ./src/docs/examples/EyeIcon/Example.js